import { render, staticRenderFns } from "./MJList.vue?vue&type=template&id=7b4efc2e&scoped=true"
import script from "./MJList.vue?vue&type=script&lang=js"
export * from "./MJList.vue?vue&type=script&lang=js"
import style0 from "./MJList.vue?vue&type=style&index=0&id=7b4efc2e&prod&lang=scss&scoped=true"
import style1 from "./MJList.vue?vue&type=style&index=1&id=7b4efc2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4efc2e",
  null
  
)

export default component.exports